export default __webpack_public_path__ + "static/media/tourer.57c3e780.svg";